import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { MdfDraftCreateInput } from "@colab/shared";

// POST /api/portal/mdf/drafts — create an empty draft scoped to an
// allocation. Server inserts a row with status='draft' and NULL amount/
// campaign_name; the partner then patches it via use-save-mdf-draft as
// they fill the form.
//
// Pessimistic: the response carries the new draft id, which the SPA needs
// before navigating to /portal/mdf/drafts/:id. No optimism.
export function useCreateMdfDraft() {
  const queryClient = useQueryClient();
  return useMutation<{ id: string }, ApiClientError, MdfDraftCreateInput>({
    mutationFn: (body) =>
      apiFetch<{ id: string }>(`/portal/mdf/drafts`, {
        method: "POST",
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.requests() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to start a new request");
    },
  });
}
